import { SearchCriteria } from "./search-criteria";

export class GetPictureSearchCriteria extends SearchCriteria {
    public Id: number;
}
